"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _MenuItem = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/MenuItem"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _routes = require("../../utils/routes");
var _utils = require("./utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  "dropdown-menu": "MinorVersionDropdownMenu__dropdown-menu__36A64",
  "dropdownMenu": "MinorVersionDropdownMenu__dropdown-menu__36A64",
  "dropdown-menu-item": "MinorVersionDropdownMenu__dropdown-menu-item__OH2Jl",
  "dropdownMenuItem": "MinorVersionDropdownMenu__dropdown-menu-item__OH2Jl",
  "selected": "MinorVersionDropdownMenu__selected__U0DN_",
  "dropdown-menu-content": "MinorVersionDropdownMenu__dropdown-menu-content__1DZ6V",
  "dropdownMenuContent": "MinorVersionDropdownMenu__dropdown-menu-content__1DZ6V",
  "dropdown-menu-icon": "MinorVersionDropdownMenu__dropdown-menu-icon__2BBjN",
  "dropdownMenuIcon": "MinorVersionDropdownMenu__dropdown-menu-icon__2BBjN",
  "dropdown-menu-toggle": "MinorVersionDropdownMenu__dropdown-menu-toggle__38yCq",
  "dropdownMenuToggle": "MinorVersionDropdownMenu__dropdown-menu-toggle__38yCq",
  "head-item": "MinorVersionDropdownMenu__head-item__1rmYv",
  "headItem": "MinorVersionDropdownMenu__head-item__1rmYv",
  "list": "MinorVersionDropdownMenu__list__e4jsf",
  "minor-version-status": "MinorVersionDropdownMenu__minor-version-status__3h1rH",
  "minorVersionStatus": "MinorVersionDropdownMenu__minor-version-status__3h1rH",
  "label": "MinorVersionDropdownMenu__label__2pr6q",
  "version-group": "MinorVersionDropdownMenu__version-group__2u7BW",
  "versionGroup": "MinorVersionDropdownMenu__version-group__2u7BW",
  "minor-version-label": "MinorVersionDropdownMenu__minor-version-label__qXW2J",
  "minorVersionLabel": "MinorVersionDropdownMenu__minor-version-label__qXW2J",
  "last-item": "MinorVersionDropdownMenu__last-item__3OFzm",
  "lastItem": "MinorVersionDropdownMenu__last-item__3OFzm",
  "visibility": "MinorVersionDropdownMenu__visibility__1QB4v",
  "minor-version": "MinorVersionDropdownMenu__minor-version__Ecwaq",
  "minorVersion": "MinorVersionDropdownMenu__minor-version__Ecwaq",
  "minor-version-non-api": "MinorVersionDropdownMenu__minor-version-non-api__QeYVC",
  "minorVersionNonApi": "MinorVersionDropdownMenu__minor-version-non-api__QeYVC",
  "sub-list": "MinorVersionDropdownMenu__sub-list__MQ-P0",
  "subList": "MinorVersionDropdownMenu__sub-list__MQ-P0",
  "transparent-button": "MinorVersionDropdownMenu__transparent-button___liLY",
  "transparentButton": "MinorVersionDropdownMenu__transparent-button___liLY"
};
/* eslint-disable @typescript-eslint/no-use-before-define */

require('./MinorVersionDropdownMenu.css');
var MinorVersionDropdownMenu = function MinorVersionDropdownMenu(_ref) {
  var asset = _ref.asset,
    assetMinorVersions = _ref.assetMinorVersions,
    onMinorVersionChange = _ref.onMinorVersionChange;
  var testId = 'asset-minor-versions';
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isDropdownOpen = _useState2[0],
    setIsDropdownOpen = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    minorVersionOptions = _useState4[0],
    setMinorVersionOptions = _useState4[1];
  var dropdownRef = (0, _react.useRef)(null);
  var _useState5 = (0, _react.useState)(''),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    minorSelected = _useState6[0],
    setMinorSelected = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    statusSelected = _useState8[0],
    setStatusSelected = _useState8[1];
  var nextIndexFn = {
    ArrowUp: _utils.getPreviousIndex,
    ArrowDown: _utils.getNextIndex
  };
  var _useState9 = (0, _react.useState)(-1),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    itemFocused = _useState10[0],
    setItemFocused = _useState10[1];
  var portalContext = (0, _react.useContext)(_exchangeReactHooks.AssetPortalContext);
  var isVersionGroupNavigation = portalContext.versionsNavigation === 'version-group';
  (0, _react.useEffect)(function () {
    var minorVersionInitOptions = (0, _utils.getMinorVersionOptions)(assetMinorVersions, isVersionGroupNavigation, asset);
    setMinorVersionOptions(minorVersionInitOptions);
  }, [assetMinorVersions]);
  var getPath = (0, _exchangeReactHooks.useGetPath)();
  var location = (0, _reactRouterDom.useLocation)();
  var match = (0, _reactRouterDom.useRouteMatch)();
  var routes = (0, _exchangeReactHooks.usePortalRoutes)();
  var getVersionPath = function getVersionPath(params) {
    var fullVersionPath = getPath('minor', params);
    if ((0, _routes.hasRouteParams)(match, location, routes)) {
      return fullVersionPath;
    }
    var routeURL = (0, _routes.resolveRouteURL)(match, location);
    var _fullVersionPath$spli = fullVersionPath.split('?'),
      _fullVersionPath$spli2 = (0, _slicedToArray2.default)(_fullVersionPath$spli, 2),
      versionPath = _fullVersionPath$spli2[0],
      queryParams = _fullVersionPath$spli2[1];
    return "".concat(versionPath).concat(routeURL.startsWith('/') ? routeURL.substring(1) : routeURL).concat(queryParams ? "?".concat(queryParams) : '');
  };
  var handleMinorVersionChange = function handleMinorVersionChange(_ref2) {
    var minorVersion = _ref2.minorVersion,
      status = _ref2.status;
    var path = getVersionPath(_objectSpread(_objectSpread({}, asset), {}, {
      minorVersion: minorVersion,
      status: status
    }));
    onMinorVersionChange({
      asset: asset,
      status: status,
      assetMinorVersions: assetMinorVersions,
      selectedMinor: minorVersion,
      path: path
    });
  };
  (0, _react.useEffect)(function () {
    document.addEventListener('mousedown', handleGlobalMouseDown);
    return function () {
      document.removeEventListener('mousedown', handleGlobalMouseDown);
    };
  });
  var isSelectedMinorVersion = function isSelectedMinorVersion(minorVersion, status) {
    return minorVersion === asset.minorVersion && status === asset.status;
  };
  var handleGlobalMouseDown = function handleGlobalMouseDown(event) {
    var _dropdownRef$current;
    var isTargetInDropdown = dropdownRef === null || dropdownRef === void 0 || (_dropdownRef$current = dropdownRef.current) === null || _dropdownRef$current === void 0 ? void 0 : _dropdownRef$current.contains(event.target);
    if (!isTargetInDropdown && isDropdownOpen) {
      closeDropdown();
    }
  };
  var toggleDropdown = function toggleDropdown() {
    setIsDropdownOpen(!isDropdownOpen);
  };
  var closeDropdown = function closeDropdown() {
    setIsDropdownOpen(false);
    setItemFocused(-1);
    setStatusSelected('');
    setMinorSelected('');
  };
  var handleChange = function handleChange(event, $minorVersionValue, status) {
    event.stopPropagation();
    closeDropdown();
    handleMinorVersionChange(_objectSpread(_objectSpread({}, $minorVersionValue), {}, {
      status: status
    }));
  };
  var handleSubList = function handleSubList(event, minorVersionOption) {
    event.stopPropagation();
    setMinorVersionOptions((0, _utils.toggleMinorVersionOption)(minorVersionOptions, minorVersionOption.minorVersion));
    setIsDropdownOpen(true);
  };
  var focusNextOption = function focusNextOption(eventKey) {
    var index = minorVersionOptions.findIndex(function (option) {
      return option.minorVersion === minorSelected && option.status === statusSelected;
    });
    var nextIndex = index >= 0 ? nextIndexFn[eventKey](index, minorVersionOptions.length) : 0;
    var nextOption = minorVersionOptions[nextIndex];
    while (nextOption.type === 'label' || !nextOption.isRoot && !nextOption.isMinorOpen) {
      nextIndex = nextIndexFn[eventKey](nextIndex, minorVersionOptions.length);
      nextOption = minorVersionOptions[nextIndex];
    }
    setMinorSelected(nextOption.minorVersion);
    setStatusSelected(nextOption.status);
    setItemFocused(nextIndex);
  };
  var handleKeyDownButton = function handleKeyDownButton(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      toggleDropdown();
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Tab') {
      setItemFocused(-1);
      setStatusSelected('');
      setMinorSelected('');
    }
    if (event.key === 'Enter') {
      event.preventDefault();
      if (isDropdownOpen) {
        if (statusSelected === '') {
          setMinorVersionOptions((0, _utils.toggleMinorVersionOption)(minorVersionOptions, minorSelected));
        } else {
          handleMinorVersionChange({
            minorVersion: minorSelected,
            status: statusSelected
          });
          closeDropdown();
        }
      }
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDropdown();
    }
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (!isDropdownOpen) {
        toggleDropdown();
        return;
      }
      focusNextOption(event.key);
    }
  };
  var renderMinorVersion = function renderMinorVersion(minorVersion, status) {
    var versionPath = getVersionPath(_objectSpread(_objectSpread({}, asset), {}, {
      minorVersion: minorVersion,
      status: status
    }));
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, styles.selected, isSelectedMinorVersion(minorVersion, status)), styles.minorVersionStatus, isVersionGroupNavigation))
    }, versionPath ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: versionPath,
      tabIndex: -1
    }, (0, _utils.getStatusLabel)(status)) : /*#__PURE__*/_react.default.createElement("span", null, (0, _utils.getStatusLabel)(status)));
  };
  var renderOption = function renderOption(option, index) {
    if (option.type === 'label') {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: "".concat(option.minorVersion, "-").concat(index),
        role: "menuitem"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: styles.label
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: styles.versionGroup
      }, option.versionGroup), /*#__PURE__*/_react.default.createElement("span", {
        className: styles.visibility
      }, option.visibility)));
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: "".concat(option.minorVersion, "-").concat(index)
    }, option.isRoot ? /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      getRef: function getRef(element) {
        if (index === itemFocused && element) {
          element.focus();
        }
      },
      role: "menuitem",
      testId: testId && "".concat(testId, "-list-item-").concat(index),
      onClick: function onClick(event) {
        return handleSubList(event, option);
      },
      className: (0, _classnames.default)(styles.minorVersion, (0, _defineProperty2.default)({}, styles.minorVersionNonApi, !isVersionGroupNavigation)),
      tabIndex: "-1",
      key: option.minorVersion
    }, option.minorVersion, ".x") : option.isMinorOpen ? /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      getRef: function getRef(element) {
        if (index === itemFocused && element) {
          element.focus();
        }
      },
      role: "menuitem",
      className: (0, _classnames.default)(styles.dropdownMenuItem, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, styles.selected, isSelectedMinorVersion(option.minorVersion, option.status)), styles.lastItem, option.isLatest)),
      tabIndex: "-1",
      testId: testId && "".concat(testId, "-list-item-").concat(index),
      onClick: function onClick(event) {
        return handleChange(event, option, option.status);
      },
      key: "".concat(option.minorVersion, "-").concat(option.status)
    }, renderMinorVersion(option.minorVersion, option.status)) : null);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
    id: "asset-minor-versions-dropdown",
    type: "button",
    className: (0, _classnames.default)(styles.transparentButton, styles.dropdownMenuToggle),
    onMouseDown: toggleDropdown,
    onKeyDown: handleKeyDownButton
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: styles.headItem
  }, asset.minorVersion, ".x"), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: styles.dropdownMenuIcon,
    name: "arrow-down-small",
    "data-test-id": "".concat(testId, "-icon"),
    size: 30
  })), isDropdownOpen ? /*#__PURE__*/_react.default.createElement("div", {
    ref: dropdownRef,
    className: (0, _classnames.default)(styles.dropdownMenu, styles.dropdownMenuToggle),
    "data-test-id": testId
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.dropdownMenuContent,
    "data-test-id": testId && "".concat(testId, "-content")
  }, /*#__PURE__*/_react.default.createElement("ul", {
    "data-test-id": testId && "".concat(testId, "-list"),
    className: styles.list,
    tabIndex: 0,
    role: "menu",
    onMouseDown: toggleDropdown,
    onKeyDown: handleKeyDown
  }, minorVersionOptions.map(renderOption)))) : null);
};
var _default = exports.default = MinorVersionDropdownMenu;
//# sourceMappingURL=MinorVersionDropdownMenu.js.map